import axios from "axios"
import environment from 'environment';
axios.defaults.baseURL = environment.probateAPIURL;
axios.defaults.headers = {
    'Content-Type': 'application/json',
  }
//Content-type : multipart/form-data //overide if file upload


